import { useEffect, useRef } from 'react';
import i18n from '../../i18n';
import {
  SiteHeader, Hero, About, EducationalContents, Demo, Pedagogy, Schools, Trust,
  Pricing, Contact, SiteFooter, SoonToast, WhatsAppButton, ScrollNext,
} from './sections';
import { HOME_TEXT, HomeLang, HomeTextContext } from './text';
import { initKhotoua } from './khotoua';
import './khotoua.css';

const TITLES: Record<HomeLang, string> = {
  ar: 'خطوة Khotoua | تطبيق تعليمي وألعاب تعليمية للأطفال في تونس (5–12 سنة)',
  fr: 'Khotoua | Application éducative et jeux éducatifs pour enfants en Tunisie (5–12 ans)',
  en: 'Khotoua | Educational app and learning games for kids in Tunisia (ages 5–12)',
};

type Props = { lang: HomeLang };

// One page per language (/, /fr/, /en/), like the design. The per-language
// <head> is written into build/{fr,en}/index.html by scripts/postbuild.js.
const Home = ({ lang }: Props) => {
  const root = useRef<HTMLDivElement>(null);
  const rtl = lang === 'ar';

  useEffect(() => {
    document.title = TITLES[lang];
    document.documentElement.lang = lang;
    document.documentElement.dir = rtl ? 'rtl' : 'ltr';
    // the privacy page opens in the language the visitor was reading
    if (i18n.language !== lang) i18n.changeLanguage(lang);
    // The browser looks for #section before React has rendered it
    const target = window.location.hash && document.getElementById(decodeURIComponent(window.location.hash.slice(1)));
    if (target) target.scrollIntoView({ behavior: 'instant' as ScrollBehavior });
    return initKhotoua(root.current!, lang);
  }, [lang, rtl]);

  return (
    <HomeTextContext.Provider value={HOME_TEXT[lang]}>
      <div ref={root} className="kh-root" dir={rtl ? 'rtl' : 'ltr'} style={{ fontFamily: "'IBM Plex Sans Arabic', Tahoma, sans-serif", color: "#121A4A", background: "#F3F5FF", overflowX: "clip" }}>
        <SiteHeader />
        <Hero />
        <About />
        <EducationalContents />
        <Demo />
        <Pedagogy />
        <Schools />
        <Trust />
        <Pricing />
        <Contact />
        <SiteFooter />
        <SoonToast />
        <WhatsAppButton />
        <ScrollNext />
      </div>
    </HomeTextContext.Provider>
  );
};

export default Home;
